import { RadialLinearScale } from 'chart.js';

import { UserSkillNames } from 'src/features/management-dashboard/reports/views/skills-matrix/skills-matrix.types';

export interface SkillsMatrixScore {
  label: string;
  code: UserSkillNames;
  score: number;
}

export interface SkillsMatrix {
  skills: SkillsMatrixScore[];
}

export type GraphColorScheme = {
  grid: string;
  text: string;
  hoverText: string;
  backgroundGradientStart: string;
  backgroundGradientMiddle: string;
  backgroundEdge: string;
  borderColor: string;
};

export interface ExtendedRadialLinearScale extends RadialLinearScale {
  _pointLabelItems: {
    left: number;
    right: number;
    top: number;
    bottom: number;
  }[];
}

export const SkillMatrixSegment = {
  ENTRY: 'entry',
  JUNIOR: 'junior',
  MID: 'mid',
  SENIOR: 'senior',
  ALL: 'all',
} as const;

export type SkillMatrixSegmentValue = (typeof SkillMatrixSegment)[keyof typeof SkillMatrixSegment];
